import { render, staticRenderFns } from "./CompanyAssetTypeModal.vue?vue&type=template&id=451a64fe&"
import script from "./CompanyAssetTypeModal.vue?vue&type=script&lang=js&"
export * from "./CompanyAssetTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports